module.exports = __webpack_public_path__ + "img/MozillaBrowser.eb1324e4.svg";